import BaseControls from '@aytm/app/stats/page/question-views/sh/components/Controls'
import { SHELF_VIEW_OPTIONS } from '@aytm/app/stats/page/question-views/sh/lib/constants'

const Controls = ({ showPrice, ...props }) => {
  const options = SHELF_VIEW_OPTIONS

  return <BaseControls type="shelf" options={options} {...props} />
}

const { type, ...propTypes } = BaseControls.propTypes

Controls.propTypes = {
  ...propTypes
}

Controls.displayName = 'Controls'

export default Controls
